import React, { useState } from 'react';

const MyScheduleFeesContext = React.createContext();

export const MyScheduleFeesContextProvider = ({ children }) => {
    const consultationTypeData = [
        { value: "0", id: "0", label: "Tele-Consult Regular" },
        { value: "1", id: "1", label: "Tele-Consult Follow-Up" },
        { value: "5", id: "5", label: "In-Clinic Regular" },
        { value: "6", id: "6", label: "In-Clinic Follow-Up" },
    ];

    const [consultationTypes, setConsultationTypes] = useState(consultationTypeData);
    const [procedures, setProcedures] = useState([]);
    const [selectedConsultationType, setSelectedConsultationType] = useState({ value: "0", id: "0", label: "Tele-Consult Regular", consultation_duration: "0", common_procedure: false });

    return (
        <MyScheduleFeesContext.Provider value={{
            consultationTypes, setConsultationTypes,
            procedures, setProcedures,
            selectedConsultationType, setSelectedConsultationType
        }}>
            {children}
        </MyScheduleFeesContext.Provider>
    )
}

export default MyScheduleFeesContext;
